import React from 'react'
import { withAuthProvider } from '../../lib/auth'
import { MyAccountButton } from '@pga/pga-component-library'
import MemberDrop from './MemberDrop'

export const AuthHeader = ({ isLoggedIn, me, options, loading, meEmailMigrationData, onToggleDoNotShowAgain }) => (
  isLoggedIn
    ? <MemberDrop {...{ me, options, loading, meEmailMigrationData, onToggleDoNotShowAgain }} />
    : <MyAccountButton />
)

export default withAuthProvider(AuthHeader)
